import { kebabCase } from "lodash";
import { useCustomColors } from "@circle-react-shared/BuilderUI/ThemeConfiguration/hooks/useCustomColors";
import { Background } from "./Background";
import { Border } from "./Border";
import { BorderRadiusSelector } from "./BorderRadiusSelector";
import { Spacing } from "./Spacing";
import { Text } from "./Text";

export type ButtonType = "primary_button" | "secondary_button";
export type ButtonVariant = "default" | "hover";

interface FormButtonStylesProps {
  buttonType: ButtonType;
  buttonVariant: ButtonVariant;
}

export const generateFormItemName = (
  buttonType: ButtonType,
  buttonVariant: ButtonVariant,
  name: string,
) =>
  `theme.${buttonType}.theme-website-${kebabCase(buttonType)}-${buttonVariant}-${name}`;

export const FormButtonStyles = ({
  buttonType,
  buttonVariant,
}: FormButtonStylesProps) => {
  const {
    customColors,
    handleAddCustomColor,
    themeColors,
    flattenedCssVariables,
  } = useCustomColors();

  return (
    <div
      className="divide-primary h-[calc(100%-80px)] divide-y overflow-y-auto"
      key={`${buttonType}-${buttonVariant}`}
    >
      <Background
        buttonType={buttonType}
        buttonVariant={buttonVariant}
        flattenedCssVariables={flattenedCssVariables}
        themeColors={themeColors}
        customColors={customColors}
        onAddCustomColor={handleAddCustomColor}
      />
      <Text
        buttonType={buttonType}
        buttonVariant={buttonVariant}
        flattenedCssVariables={flattenedCssVariables}
        themeColors={themeColors}
        customColors={customColors}
        onAddCustomColor={handleAddCustomColor}
      />
      <BorderRadiusSelector
        buttonType={buttonType}
        buttonVariant={buttonVariant}
      />
      <Border
        buttonType={buttonType}
        buttonVariant={buttonVariant}
        flattenedCssVariables={flattenedCssVariables}
        themeColors={themeColors}
        customColors={customColors}
        onAddCustomColor={handleAddCustomColor}
      />
      <Spacing buttonType={buttonType} buttonVariant={buttonVariant} />
    </div>
  );
};
